'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvSubscriptions = function AvSubscriptions(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z' })
  );
};
AvSubscriptions = (0, _pure2.default)(AvSubscriptions);
AvSubscriptions.displayName = 'AvSubscriptions';
AvSubscriptions.muiName = 'SvgIcon';

exports.default = AvSubscriptions;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/av/subscriptions.js
// module id = 2743
// module chunks = 0